
import { supabase } from "@/integrations/supabase/client";

interface SearchResult {
  title: string;
  link: string;
  snippet: string;
  displayLink: string;
}

interface WebSearchResponse {
  searchResults: SearchResult[];
  message?: string;
  error?: string;
}

export const performLegalWebSearch = async (
  query: string,
  country: string,
  searchType: 'Local Laws' | 'Past Cases' | 'Compare Countries'
): Promise<WebSearchResponse> => {
  try {
    const { data, error } = await supabase.functions.invoke('web-search-service', {
      body: { 
        query, 
        country, 
        searchType 
      }
    });

    if (error) {
      console.error('Web search error:', error);
      return { searchResults: [], error: error.message };
    }

    return data;
  } catch (error: any) {
    console.error('Legal web search failed:', error);
    return { searchResults: [], error: error.message || 'Web search failed' };
  }
};

export const formatSearchResultsForAI = (searchResults: SearchResult[]): string => {
  if (!searchResults || searchResults.length === 0) {
    return 'No recent web search results available.';
  }

  return searchResults.map((result, index) => 
    `[Result ${index + 1}]
Title: ${result.title}
Source: ${result.displayLink}
Content: ${result.snippet}
Link: ${result.link}
---`
  ).join('\n');
};
